import { pxToRem, threeDotDoughColorPalette } from "@getbread/dough";
import { styled } from "@mui/material/styles";
import { NavLink as RouterNavLink } from "react-router";
import type { FCWithChildren } from "../../api-client/resources/types/sharedTypes";
import { STYLE_CONSTANTS } from "../../utils/global.constants";

const SubNavBarWrapper = styled("div")`
	width: 100%;
	position: sticky;
	top: 0;
	background-color: #fff;
	z-index: ${STYLE_CONSTANTS.appBarZIndex};
	padding: 12px 16px;
	align-self: center;

	@media (min-width: ${(props) => props.theme.breakpoints.values.sm}px) {
		top: ${STYLE_CONSTANTS.nav.headerHeight};
	}
`;

const SubNavBarStyled = styled("div")(({ theme }) => ({
	maxWidth: pxToRem(540),
	height: pxToRem(48),
	margin: "0 auto",
	boxShadow: "var(--shadow-nav)",
	display: "flex",
	justifyContent: "flex-start",
	borderRadius: pxToRem(100),
	padding: "var(--space-xs)",
	border: `1px solid ${threeDotDoughColorPalette.main.secondary}`,

	[`@media (min-width:${theme.breakpoints.values.sm}px)`]: {
		top: STYLE_CONSTANTS.nav.headerHeight,
		height: pxToRem(56),
	},
}));

export const PageTitle = styled("div")`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: clamp(${pxToRem(325)}, 90vw, ${pxToRem(540)});
	max-width: ${pxToRem(540)};
	padding: 0 ${pxToRem(10)};
	height: auto;
`;
export const PageTabs = styled("nav")`
	flex: 1;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
`;

export const HeaderText = styled("h1")`
	width: 100%;
	font-size: ${pxToRem(32)};
	font-weight: 700;
`;

export const NavTabLink = styled(RouterNavLink)`
	flex: 1;
	transition: color ${({ theme }) => theme.transitions.duration.shorter}ms;
	font-size: ${pxToRem(16)};
	font-weight: 600;
	line-height: 1;
	padding: var(--space-s);
	text-decoration: none;
	color: ${threeDotDoughColorPalette.main.secondary};
	display: flex;
	align-items: center;
	height: 100%;
	border-radius: ${pxToRem(100)};
	border-bottom: 3px solid transparent;
	width: 50%;
	justify-content: center;

	@media (min-width: ${(props) => props.theme.breakpoints.values.sm}px) {
		width: auto;
		min-width: ${pxToRem(190)};
		padding: var(--space-xs) var(--space-xxl);
	}

	&.active {
		color: ${({ theme }) => theme.palette.colors.white};
		background: ${({ theme }) => theme.palette.primary.main};
	}
`;

export const SubNavBar: FCWithChildren = ({ children }) => (
	<SubNavBarWrapper>
		<SubNavBarStyled>{children}</SubNavBarStyled>
	</SubNavBarWrapper>
);
